import { device } from '../device';
import { device as posDeviceApi } from '../device/api';
import { device as localHostDeviceApi } from '../device/local-host';
import { logUtil } from '../log/private';
import { logUtil as posLogUtil } from '../log/private/api';
import { log } from '../log/public';
import { log as posLogApi } from '../log/public/api';
import { log as localHostLogApi } from '../log/public/local-host';
import { Customer, order, Order } from '../order';
import { order as posOrderApi } from '../order/api';
import {
  order as localHostOrderApi,
  setCustomer,
  setOrder,
} from '../order/local-host';
import { view } from '../view';
import { view as posViewApi } from '../view/api';
import { view as localHostViewApi } from '../view/local-host';
import { sdk as posSdkApi } from './api';
import { sdk as localHostSdkApi, setContext } from './local-host';
import {
  type Context,
  Environment,
  type SDKActionCallbacks,
  type SdkApi,
  type SdkInitializeOptions,
} from './types';

function initializeLocalHostData({
  context,
  order,
  customer,
}: {
  context?: Context;
  order?: Order;
  customer?: Customer;
}) {
  if (context) {
    setContext(context);
  }

  if (order) {
    setOrder(order);
  }

  if (customer) {
    setCustomer(customer);
  }
}

const sdk: SdkApi = {
  initialize(
    callbacks: SDKActionCallbacks,
    options?: SdkInitializeOptions
  ): Promise<Context> {
    if (options?.environment === Environment.LOCAL_HOST) {
      // BigInt unfortunately does not have its own toJSON prototype so we have
      // define our own.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (BigInt.prototype as any).toJSON = function () {
        return this.toString();
      };

      // Use localhost APIs.
      Object.assign(device, { deviceApi: localHostDeviceApi });
      Object.assign(order, { orderApi: localHostOrderApi });
      Object.assign(view, { viewApi: localHostViewApi });
      Object.assign(this, { sdkApi: localHostSdkApi });
      Object.assign(log, { logApi: localHostLogApi });

      if (options?.localHostData) {
        initializeLocalHostData(options.localHostData);
      }
    } else {
      // Use POS APIs.
      Object.assign(device, { deviceApi: posDeviceApi });
      Object.assign(order, { orderApi: posOrderApi });
      Object.assign(view, { viewApi: posViewApi });
      Object.assign(logUtil, { logApi: posLogUtil });
      Object.assign(log, { logApi: posLogApi });
      Object.assign(this, { sdkApi: posSdkApi });
    }

    return this.sdkApi.initialize(callbacks);
  },
};

export { Environment } from './types';
export type {
  ConfigurationsContext,
  Context,
  DeviceContext,
  EmployeeContext,
  SDKActionCallbacks,
  SdkApi,
  SdkInitializeOptions,
} from './types';
export { sdk };
